// extracted by mini-css-extract-plugin
module.exports = {"hideProductsBar":"Header-module__hideProductsBar___O1q9F","hideCurrencyPicker":"Header-module__hideCurrencyPicker___Iq3Hp"};